import { render, staticRenderFns } from "./RelatedServiceTemplate.vue?vue&type=template&id=e1953c54&"
import script from "./RelatedServiceTemplate.vue?vue&type=script&lang=js&"
export * from "./RelatedServiceTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports